import { usePrimaryPage } from '@/PageManager'
import { unwrappedFeedAtom } from '@/atoms/feed'
import { useAtomValue } from 'jotai'
import HardcodedFeedItem from './HardcodedFeedItem'

export default function HardcodedFeedsSection({ collapse }: { collapse: boolean }) {
  const { current, display } = usePrimaryPage()
  const feed = useAtomValue(unwrappedFeedAtom)

  const feeds = window.hallway.universe.hardcodedFeeds
  const activeIndex = feed && 'hardcodedFeed' in feed ? feed.hardcodedFeed : -1

  return (
    <>
      {feeds.map((item, index) => {
        const active = display && current === 'home' && activeIndex === index
        return (
          <HardcodedFeedItem
            key={index}
            item={item}
            index={index}
            collapse={collapse}
            active={active}
          />
        )
      })}
    </>
  )
}
